import React from 'react';
import SEO from '../components/seo';
// import ProjectSliderMonto from '../components/projects/projectSliderMonto';
// import ProjectSliderLemosta from '../components/projects/projectSliderLemosta';
import ProjectSliderW from '../components/projects/projectSliderW';
// import ProjectSliderLemochlo from '../components/projects/projectSliderLemochlo';
// import ProjectSliderHero from '../components/projects/projectSliderHero';
// import ProjectSliderBook from '../components/projects/projectSliderBook';
// import ProjectSliderTampack from '../components/projects/projectSliderTampack';
// import { HashLink } from 'react-router-hash-link';
// import $ from 'jquery';

const ProjectPageW = () => {
  // $('a[href^="#"]').click(function () {
  //   var href = $(this).attr('href');
  //   var target = $(href);
  //   var position = target.offset().top;
  //   $('body,html').stop().animate({ scrollTop: position }, 500);
  // });
  return (
    <>
      <SEO title="レモンスタンド広島 | mon-to.9 | Our Projects" />
      <section className="projectVisual">
        <h1 className="visual--title">
          <span>Our</span> Projects
        </h1>
        <p className="visual--desc">
          全人類の健康をアップデートさせるべく
          <br />
          サイレンサーが展開するプロジェクト。
        </p>
      </section>
      <section className="projectWrap">
        <div className="projectBox" id="p1">
          <h2 className="projectName">
            LEMON STAND HIROSHIMA / <br className="sp" />
            mon-to.9
          </h2>
          <p className="projectCopy">
            広島特産レモンを使用した上質なレモンサワーと丁寧にセレクトされたナチュラルワインを飲みながら「一つ上をいく本物の広島遊び」の起点となる酒場。
          </p>
          <div className="projectSlider--wrap">
            <ProjectSliderW />
          </div>
          <h3 className="projectOverview">
            昼と夜の広島観光活況情報発信基地。
          </h3>
          <div className="projectText">
            <p>
              酒場の“賑わい”は何処からやってくるのだろう？
              <br />
              美味しい食事、気の置けない友達etc...
              <br />
              理由を探れば人それぞれ多様な答えがそこにはある。
            </p>
            <p>
              レモスタとモントナイン。
              <br />
              昼と夜。
              <br />
              ２つの異なる側面を持つ店を”レモンサワーとナチュラルワイン”で繋いでみると似て非なる不思議な光景が見えてくる。
              <br className="sp" />
              昼の明るい表通りに一滴の闇を落とすレモンスタンド。
              <br className="sp" />
              夜の暗い繁華街に光降り注ぐ”夜の無料案内所”をも内包するモントナイン。
              <br className="sp" />
              街、そのエリアの既存の表情に敢えて当てた裏の概念により生じたその摩擦は常に自然な熱を孕んでいる。
            </p>
            <p>
              レモンサワーで生まれる対話と、ナチュラルワインではじまる思考があり、そこで得られる新しい刺激(傷)は個々の次のアクションへのステップになる可能性を秘めている。
            </p>
            <p>
              「その日、その場に居合わせた人との無理のない緩やかな繋がりと対話への渇きを潤す現代の酒場」として。
              <br className="sp" />
              更には、「内なる最適化された時間だけではない、その外側のコミュニティへの解放区」として。
              <br className="sp" />
              モントナインとレモスタには、これからの時代のそんな”健全なる社会的役割”を担うサードプレイスでありたいとの願いを込めている。
            </p>
            <p>
              着座のボックス席では避けて通れない「人と人との視えざる境界線」が曖昧で朧げになるオールスタンディングで繰り広げられる享楽と饗宴のCOUNTER
              PLACE。
            </p>
            <p>
              光と闇が互いを掻き消し合いながら存在する様にそこにある"時の流れ方が異なる二つの酒場"。
              <br className="sp" />
              グラスの底を覗き込めば無意識に偏っていた価値観のあたらしい一面が見えるかもしれない。
            </p>
          </div>
          <ul className="projectLink">
            <li>
              <a
                href="https://www.instagram.com/lemon.stand.hiroshima/?hl=ja"
                target="_blank"
                rel="noreferrer"
              >
                LEMON STAND HIROSHIMA
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/monto.nine/?hl=ja"
                target="_blank"
                rel="noreferrer"
              >
                mon-to.9
              </a>
            </li>
            {/* <li>
              <a
                href="https://www.facebook.com/LEMON-STAND-%E5%BA%83%E5%B3%B6-1547321938737476/"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
            </li> */}
          </ul>
        </div>
        {/* <div className="projectBox" id="p1">
          <h2 className="projectName">mon-to.9</h2>
          <p className="projectCopy">
            広島レモンを使ったレモンサワーと広島県産生牡蠣の専門店「mon-to.9」。その他にも自然派ワインやジビエソーセージなど、本物だけにこだわり、選び抜かれたメニューが並ぶ一面ガラス張り4.5坪の立ち飲み屋。また、ただの立ち飲み屋ではなく、広島の特産品であるレモンと牡蠣を目当てに来た県外や海外の人に、広島の食や文化を発信する無料案内所&お土産屋でもある。
          </p>
          <div className="projectSlider--wrap">
            <ProjectSliderMonto />
          </div>
          <h3 className="projectOverview">
            あたりなレモンサワーとあたらない生牡蠣
          </h3>
          <h3 className="projectOverview">
            ゴエミヨやワカコ酒その他多数メディアにも掲載
          </h3>
          <h3 className="projectOverview">
            「1杯どうですか？」の紙をきっかけに始まる新たな繋がり
          </h3>
          <div className="projectText">
            <p>
              広島県産の無農薬レモンを使用したレモンサワーは、薄はりグラスにカチ割り氷、専用のサーバーとシロップと超強炭酸を使うこだわり。800円〜10,000円まで計7種あり、味はもちろん、ここでしか飲めないエンタメレモンサワーが売り。生牡蠣は広島県の清浄海域で育った無菌の当たらない牡蠣。広島が誇る日本一の生産量の２つを柱に、その他ナチュラルワインやクラフトビール、ジビエソーセージなど自分達が本当に美味しく身体に良いと思うものだけをメニューに並べる。また、ガラス張りの店内から掲げる「1杯どうですか？」という紙を通して店前を通るお客さんともコミュニケーションを楽しむスタイルは、4.5坪の中に20人以上の人を引き寄せる程。さらに、お客さんがお客さんを呼び込み、一体感あふれるmon-to.9ではいつも新しい繋がりが生まれる。こだわりのメニューや4.5坪が魅せる盛り上がりはゴエミヨやワカコ酒などのメディアにも多数掲載。
            </p>
          </div>
          <h3 className="projectOverview">
            ただの立ち飲みではなく、広島の食や文化の発信地
          </h3>
          <h3 className="projectOverview">
            広島を楽しんでもらうための無料案内と新しい広島土産の提案
          </h3>
          <div className="projectText">
            <p>
              オープン当初からmon-to.9は飲食店ではなく、美味しいレモンサワーが飲める「無料案内所&お土産屋」だと公言してきた。広島のレモンや生牡蠣を求めて来店される県外や海外からのお客さんに、広島をもっと楽しんでもらいたいという思いから、広島の食や文化を発信する場所にしたい、新しい広島土産を提案したいと。美味しいレモンサワーと生牡蠣を口にしながら、広島の美味しいお店や観光スポットを紹介。また、思い出に残る新しい広島土産の「レモクロ」や「金のチョコ」や「オリジナルTシャツ」なども提案している。
            </p>
          </div>
          <ul className="projectLink">
            <li>
              <a
                href="https://www.instagram.com/monto.nine/?hl=ja"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/monto9monto9/"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
            </li>
          </ul>
        </div> */}
        {/* ////////////区切り線//////////// */}
        {/* <div className="projectBox" id="p2">
          <h2 className="projectName">LEMON STAND HIROSHIMA</h2>
          <p className="projectCopy">
            昼は座り、夜は立ちと２つの顔を持つ「レモンスタンド広島」。レモンサワーと生牡蠣に加え、3種のカレーと3種の副菜があいがけになった広島カレープレートが追加。また、共通言語を持ったコミュニティづくりを目的とした、健康交流会や参加型イベント、飲食店とのコラボイベントなどを実施。お客さんのサードプレイスとなれるように居心地の良さを追求。
          </p>
          <div className="projectSlider--wrap">
            <ProjectSliderLemosta />
          </div>
          <h3 className="projectOverview">座りと立ちの2つの顔</h3>
          <h3 className="projectOverview">3種のあいがけ広島カレープレート</h3>
          <h3 className="projectOverview">TV、雑誌など多数メディア掲載</h3>
          <div className="projectText">
            <p>
              1号店「mon-to.9」のレモンサワーと生牡蠣などに加え、3種のカレーと3種の副菜をあいがけにした広島カレープレートが追加。カレープレートにも広島レモンと牡蠣の醤を使用しており、広島の特産品をカレーで表現した。昼は座りでゆっくりお酒やカレーを楽しめ、夜は照明が薄暗く落ち着いた雰囲気の立ち飲みに変わる。昼と夜で雰囲気が変わるレモンスタンド広島は県内だけに限らず、県外や海外からのお客さんも多い。また、自然派ワインも種類豊富に取り揃えており、自然派ワインを求めて来店される方も多い。ランチやカレー特集などでメディアにも多数掲載。
            </p>
          </div>
          <h3 className="projectOverview">
            お客さんのサードプレイスになれるような雰囲気作り
          </h3>
          <h3 className="projectOverview">
            食や健康など、共通言語を持ったコミュニティ作り
          </h3>
          <div className="projectText">
            <p>
              家庭や職場以外に自分の居場所を作る事が精神的な健康のアップデートに繋がるという思いから、レモンスタンド広島はお客さんのサードプレイスになれるように居心地の良さを追求。また、共通言語を持ったコミュニティ形成が社会との繋がりを感じられるのではないか、社会的健康のアップデートになるのではないかという思いから、健康交流会や食を通じた参加型イベント、飲食店とのコラボイベントなどを実施。mon-to.9同様、ただの飲食店ではなく、居心地の良さの追求や共通言語を持つコミュニティ作りなど、人々の健康アップデートをより意識した場所でもあるのがレモンスタンド広島。
            </p>
          </div>
          <ul className="projectLink">
            <li>
              <a
                href="https://www.instagram.com/lemon.stand.hiroshima/?hl=ja"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/LEMON-STAND-%E5%BA%83%E5%B3%B6-1547321938737476/"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
            </li>
          </ul>
        </div> */}{' '}
      </section>
    </>
  );
};

export default ProjectPageW;
